'use client';

import { RichTextField } from '@prismicio/client';
import { JSXMapSerializer, PrismicRichText } from '@prismicio/react';
import { Dispatch, SetStateAction, useEffect } from 'react';

import styles from './contentHeading.module.scss';

interface ContentHeadingProps {
  content: RichTextField;
  setOffsetElement: Dispatch<SetStateAction<string>>;
}

const OFFSET = 95;

export const ContentHeading = ({
  content,
  setOffsetElement,
}: ContentHeadingProps) => {
  const firstNode = content?.[0];
  const headingText = firstNode && 'text' in firstNode ? firstNode.text : '';

  const components: JSXMapSerializer = {
    heading4: ({ children }) => (
      <h4 id={headingText} className={styles.heading}>
        {children}
      </h4>
    ),
  };

  const handleScroll = () => {
    if (!headingText) return;

    const element = document.getElementById(headingText);
    if (element) {
      const elementPosition = element.getBoundingClientRect().top;
      if (elementPosition <= OFFSET && elementPosition >= 0) {
        setOffsetElement(headingText);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <PrismicRichText field={content} components={components} />;
};
